<template>
  <div class="p-4 w-full text-center">
    <div>
      <h1 class="text-xl mb-2">Thank you for completing the survey.</h1>
      <p class="text-left">We're always looking to improve our service so thank you for your feedback. If you have any other feedback or issues you'd like to raise with us, please don't hesitate to get in touch. Thank you!</p>
    </div>
  </div>
</template>

<script>
import MiniBarChart from '@/components/charts/MiniBarChart'
import axios from 'axios'
export default {
  name: 'final',
  components: {MiniBarChart},
  props: ['brandColor'],
  created () {
    let obj = localStorage.getItem('user-data')
    let data = JSON.parse(obj)

    this.avg = [1, 2, 3, 4, 5, 6, 7, 8].reduce((p, c) => data['ans_' + c] + p, 0) / 8
    if (localStorage.getItem('surveyType') !== 'generic') {
      this.img = this.getObj('company').logo
    }

    if (this.getObj('surveySubmit') === true) {
      this.surveySubmitted = true
    }
    let param = 'generic'
    if (localStorage.getItem('surveyType') !== 'generic') {
      param = this.getObj('company').link
      this.generic = false
      // param = this.$route.params.link
    }
    axios.get(`${process.env.APP_PATH}/survey/avg/${localStorage.getItem('surveyType')}/${param}`)
      .then(response => {
        this.globalAvg = response.data.avg
        localStorage.setItem('globalAvg', this.globalAvg)
      })
      .catch(e => {
        console.log(e)
      })
  },
  data () {
    return {
      img: '',
      avg: 0,
      globalAvg: 0,
      surveySubmitted: false,
      generic: true,
      pieOptions: {
        tooltips: {
          enabled: false
        },
        responsive: true,
        legend: {display: false},
        animation: {
          duration: 3000
        },
        scales: {
          yAxes: [{
            ticks: {
              min: 0,
              max: 10
            }
          }]
        }
      }
    }
  },
  methods: {
    calcAvg (avg) {
      var surveyType = localStorage.getItem('surveyType')
      if (surveyType === 'customer') {
        return parseFloat((avg * 8).toFixed(2))
      } else {
        return parseFloat((avg).toFixed(2))
      }
    },
    getObj (name) {
      let obj = localStorage.getItem(name)
      return JSON.parse(obj)
    },
    backQuestion () {
      let param = {qno: 1}
      if (localStorage.getItem('surveyType') !== 'generic') {
        param = { link: this.$route.params.link, qno: 1 }
      }
      this.$router.push({name: 'question', params: param})
    },
    goNext () {
      var surveyType = localStorage.getItem('surveyType')
      var param = {link: this.$route.params.link}
      console.log(surveyType, param)
      if (surveyType === 'generic') {
        this.$router.push(`/generic`)
      } else if (surveyType === 'customer') {
        this.$router.push(`/customer/${param.link}`)
      } else {
        this.$router.push(`/survey/${param.link}`)
      }
    }
  },
  computed: {
    pieData () {
      var arr = {
        labels: ['You', 'Market'],
        datasets: [{
          backgroundColor: ['#ef4a47', '#8f2c2b'],
          hoverBorderWidth: 0,
          data: [this.calcAvg(this.avg), this.calcAvg(this.globalAvg)]
        }]
      }
      return arr
    }
  }
}
</script>

<style>

.btn-class{
 display: inline-block;
 border:1px solid #c9ae34;
 color: #705D07;
 border-radius: 3px 3px 3px 3px;
 -webkit-border-radius: 3px 3px 3px 3px;
 -moz-border-radius: 3px 3px 3px 3px;
 font-family: Verdana;
 width: auto;
 height: auto;
 font-size: 16px;
 padding: 8px 36px;
 box-shadow: inset 0 1px 0 0 #fff6ce,inset 0 -1px 0 0 #e3c852,inset 0 0 0 1px #fce88d,0 2px 4px 0 #D4D4D4;
 -moz-box-shadow: inset 0 1px 0 0 #fff6ce,inset 0 -1px 0 0 #e3c852,inset 0 0 0 1px #fce88d,0 2px 4px 0 #D4D4D4;
 -webkit-box-shadow: inset 0 1px 0 0 #fff6ce,inset 0 -1px 0 0 #e3c852,inset 0 0 0 1px #fce88d,0 2px 4px 0 #D4D4D4;
 text-shadow: 0 1px 0 #fff;
 background-image: linear-gradient(to top, #fce374, #fcdf5b);
 background-color: #fce374;
}
.btn-class:hover, .btn-class:active{
 border:1px solid #967d09;
 color: #705D07;
 box-shadow: inset 0 1px 0 0 #fff6ce,inset 0 -1px 0 0 #e3c852,inset 0 0 0 1px #fce88d;
 -moz-box-shadow: inset 0 1px 0 0 #fff6ce,inset 0 -1px 0 0 #e3c852,inset 0 0 0 1px #fce88d;
 -webkit-box-shadow: inset 0 1px 0 0 #fff6ce,inset 0 -1px 0 0 #e3c852,inset 0 0 0 1px #fce88d;
 background-color: #fcdf5b;
}
</style>



// WEBPACK FOOTER //
// src/components/CustomerFinal.vue